import { PrintOrderSettings } from "../types/printOrder";

export const DEFAULT_PRINT_ORDER_SETTINGS: PrintOrderSettings = {
	title: 'HOA DON BAN LE',
	company_name: 'NOI THAT XBOX',
	company_address: '103 Duong so 4, Phuong Tam Phu, TP. Thu Duc, TP.HCM',
	template_html: `<div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4;">
	<div style="display: grid; grid-template-columns: 1fr 2fr 1.5fr; gap: 20px; margin-bottom: 24px; align-items: start;">
		<div style="text-align: center; color: #666;">LOGO</div>
		<div style="text-align: center;">
			<div style="font-size: 24px; font-weight: 700; margin-bottom: 8px;">{{company_name_upper}}</div>
			<div style="font-size: 18px; font-weight: 700; margin-bottom: 4px;">{{title}}</div>
			<div style="font-size: 14px; color: #666;">{{order_code}}</div>
		</div>
		<div style="text-align: right;">
			<div>{{company_address}}</div>
			<div>{{company_phone}}</div>
			<div>{{company_email}}</div>
		</div>
	</div>

	<h3 style="margin: 12px 0 8px;">THONG TIN KHACH HANG</h3>
	<table style="width: 100%; border-collapse: collapse; margin-bottom: 16px;">
		<tr><td style="border: 1px solid #ddd; padding: 6px; width: 30%;"><b>Ten khach hang</b></td><td style="border: 1px solid #ddd; padding: 6px;">{{customer_name}}</td></tr>
		<tr><td style="border: 1px solid #ddd; padding: 6px;"><b>So dien thoai</b></td><td style="border: 1px solid #ddd; padding: 6px;">{{customer_phone}}</td></tr>
		<tr><td style="border: 1px solid #ddd; padding: 6px;"><b>Dia chi</b></td><td style="border: 1px solid #ddd; padding: 6px;">{{customer_address}}</td></tr>
	</table>

	<h3 style="margin: 12px 0 8px;">CHI TIET DON HANG</h3>
	<table style="width: 100%; border-collapse: collapse; margin-bottom: 16px;">
		<thead>
			<tr>
				<th style="border: 1px solid #ddd; padding: 6px;">STT</th>
				<th style="border: 1px solid #ddd; padding: 6px;">Tên sản phẩm</th>
				<th style="border: 1px solid #ddd; padding: 6px;">Màu sắc</th>
				<th style="border: 1px solid #ddd; padding: 6px;">Số lượng</th>
				<th style="border: 1px solid #ddd; padding: 6px;">Đơn vị</th>
				<th style="border: 1px solid #ddd; padding: 6px; text-align: right;">Đơn giá</th>
				<th style="border: 1px solid #ddd; padding: 6px; text-align: right;">Thành tiền</th>
			</tr>
		</thead>
		<tbody>{{items_rows}}</tbody>
	</table>

	<div style="margin-bottom: 16px;">
		<div><b>{{terms_title}}</b></div>
		<div>{{terms_html}}</div>
	</div>

	<div style="margin-bottom: 16px;">
		<div><b>{{warranty_title}}</b></div>
		<div>+ {{warranty_description}}</div>
		<div>{{warranty_extra_html}}</div>
	</div>

	<div style="margin-bottom: 16px;">
		<div><b>{{non_warranty_title}}</b></div>
		<div>{{non_warranty_html}}</div>
	</div>

	<div style="text-align: right; margin-top: 24px;">{{footer_city}}, Ngay {{current_day}} Tháng {{current_month}} Nam {{current_year}}</div>
	<div style="text-align: right; margin-top: 8px;">NV ban hang: {{sales_employee_name}} - {{sales_employee_phone}}</div>
</div>`,
	terms_title: '* THOA THUAN CHUNG:',
	terms_items: [
		'Các thông số kỹ thuật, chất liệu, màu sắc và giá thành đã chốt có giá trị như hợp đồng thi công nội thất.',
		'Khach hang thanh toan 100% gia tri don hang khi ky ket hop dong va truoc khi cong ty xuat kho.',
		'Khach hang chiu trach nhiem bao quan hang hoa tai cong trinh khi khong co mat nguoi ben cong ty.',
		'Khach hang tu xin giay phep thi cong tai cong trinh (neu co).',
		'Khach hang kiem tra va nghiem thu san pham ngay sau khi lap rap hoan thien.',
		'Sau 30 ngay ke tu ngay thoa thuan giao hang, neu khach hang van khong nhan hang thi cong ty se huy coc va thanh ly hang.',
	],
	warranty_title: '* THOI HAN BAO HANH: 2 nam ke tu ngay ban hang tren hoa don.',
	warranty_description: 'Den dien va cac phu kien khac bao hanh 6 thang ke tu ngay ban tren hoa don.',
	warranty_extra_items: [],
	non_warranty_title: '* CAC TRUONG HOP KHONG DUOC BAO HANH:',
	non_warranty_items: [
		'San pham su dung trong moi truong am uot hoac bi tac dong cua thien tai, chay no, ...',
		'Khach hang lam roi vo hoac tu y di doi, thao lap.',
	],
	footer_city_label: 'HCM',
	sales_staff_phone: '0939 147 233',
}